<p id="title" class="headline-small">
  {{ (assignMultiple ? 'caseOverview.assignCaseMultiple.title' : 'caseOverview.assignCase.title') | translate }}
</p>
<mat-dialog-content id="content">
  <div class="flexColumnContainer">
    <span id="text" class="body-medium">
      {{ (assignMultiple ? 'caseOverview.assignCaseMultiple.text' : 'caseOverview.assignCase.text') | translate:{caseCount: assignMultipleCount} }}
    </span>
    <app-user-selection
      (userSelected)="userSelected($event)"
      (userDeselected)="userDeselected()"
      [canCreateUser]="false"
      [canSelectUser]="true"
      [prefilledUser]="preFilledUser()"
      [teamId]="teamId"
    ></app-user-selection>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ (assignMultiple ? 'caseOverview.assignCaseMultiple.buttons.cancel.label' : 'caseOverview.assignCase.buttons.cancel.label') | translate }}
  </button>
  <button mat-flat-button [mat-dialog-close]="chosenUser"
          [disabled]="!chosenUser">
    {{ (assignMultiple ? 'caseOverview.assignCaseMultiple.buttons.assign.label' : 'caseOverview.assignCase.buttons.assign.label') | translate }}
  </button>
</mat-dialog-actions>
